import {
  Text as ChakraText,
  TextProps as ChakraTextProps,
} from '@chakra-ui/react'
import { SwashbuckleComponentProps } from '../../types'

export type TextProps = SwashbuckleComponentProps &
  Omit<ChakraTextProps, 'fontSize' | 'letterSpacing' | 'lineHeight'>

export const Text = ({
  'data-qa': dataQa,
  className,
  ...chakraProps
}: TextProps) => (
  <ChakraText data-qa={dataQa} className={className} {...chakraProps} />
)

Text.displayName = 'Text'
